import type { ReactNode } from 'react';

import type { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export interface QueryProviderProps {
  client: QueryClient;
  children: ReactNode;
  showDevtools?: boolean;
}

export function QueryProvider({ client, children, showDevtools = false }: QueryProviderProps) {
  return (
    <QueryClientProvider client={client}>
      {children}
      {showDevtools && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />}
    </QueryClientProvider>
  );
}
